import React from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { closeModal } from '../../../../redux/slices/modal';
import { selectModalData } from '../../../../redux/selectors/modal';
import { IThreadCommentDeleteInput } from '../../../../utils/apollo/graphqlSchema';
import useDeleteThreadComment from '../../hooks/useDeleteThreadComment';
import ConfirmationModal from '../../../ConfirmationModal';

const DeleteThreadCommentModal = () => {
  const dispatch = useAppDispatch();

  const modalData = useAppSelector(
    selectModalData,
  ) as IThreadCommentDeleteInput;

  const { loading, deleteThreadComment } = useDeleteThreadComment();

  const handleClose = () => {
    dispatch(closeModal());
  };

  const handleSubmit = async () => {
    await deleteThreadComment(modalData);
    handleClose();
  };

  return (
    <ConfirmationModal
      open
      onClose={handleClose}
      onSubmit={handleSubmit}
      header={'Delete Confirmation'}
      confirmActionLabel={'Delete'}
      disabled={loading}
    >
      Are you sure you want to delete this comment?
    </ConfirmationModal>
  );
};

export default DeleteThreadCommentModal;
